import { Placeholder } from "react-bootstrap";
import { Box } from "../styled/Elements";
import styled from "styled-components";

const SkeletonContainer = styled(Box)`
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;

  .placeholder {
    background-color: #a7a7a7;
  }
`;

const InputSkeleton = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background: #e0e0e0;
`;

const ImageUploadSkeleton = styled.div`
  width: 100px;
  height: 100px;
  background: #e0e0e0;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FormSkeleton = () => {
  return (
    <SkeletonContainer>
      <InputSkeleton />
      <InputSkeleton />
      <InputSkeleton />
      <InputSkeleton />
      <InputSkeleton />
      <InputSkeleton />
      <ImageUploadSkeleton>
        <Placeholder xs={6} size="lg" animation="wave" />
      </ImageUploadSkeleton>
    </SkeletonContainer>
  );
};

export default FormSkeleton;
